import { Navigation, Thumbs, Pagination, Grid } from 'swiper';

export const thumbsConfig = (slidesPerView, vertical) => {
  const config = {
    modules: [Navigation, Grid],
    loop: false,
    slidesPerView: slidesPerView,
    slidesPerGroup: 1,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next--main-product',
      prevEl: '.swiper-button-prev--main-product',
    },
    breakpoints: {
      992: {
        grid: {
          rows: 2,
          spaceBetween: 10,
        },
      },
    }
  };
  // eslint-disable-next-line no-unused-expressions
  vertical && (config.direction = 'vertical');

  return config;
};

export const principalConfig = (thumbnails, vertical) => {
  const config = {
    modules: [Navigation, Thumbs, Pagination],
    spaceBetween: 10,
    thumbs: {
      swiper: thumbnails,
    },
    pagination: {
      el: `.product-js .swiper-pagination`,
      type: 'bullets',
      clickable: true,
    },
  };
  // eslint-disable-next-line no-unused-expressions
  vertical && (config.direction = 'vertical');

  return config;
};
